module.exports = {"selectpicker":{"none_selected_text":"Nessuna selezione zzz"}};